/// <amd-module name="Artifacts/Npm/commands/Download" />
import { NpmActions } from "Artifacts/Npm/redux";
import { getDownloadCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createDownloadCommand = getDownloadCommandCreator(NpmActions.download);
